module.exports = __webpack_public_path__ + "img/HFCT-50.65cb79f8.png";